import React, { useEffect, useMemo, useState } from "react";
import PhoneInput from "react-phone-number-input/input";
import { getCountries, getCountryCallingCode } from "libphonenumber-js";
import { Styles } from "./styles";

const PhoneNumberInput = ({ fieldItem, validateOnChange }) => {
  const {
    value,
    errorMessage,
    isDisabled,
    borderColor,
    placeholder,
    onChange,
    defaultCountry = "SY",
    countries,
  } = fieldItem;

  const [selectedCountry, setSelectedCountry] = useState(defaultCountry);

  useEffect(() => {
    setSelectedCountry(defaultCountry);
  }, [defaultCountry]);

  const availableCountries = useMemo(
    () => (Array.isArray(countries) && countries.length ? countries : getCountries()),
    [countries],
  );

  const getFlagEmoji = (countryCode) =>
    countryCode
      .toUpperCase()
      .replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt()));

  const handleChange = (phoneValue) => onChange?.(phoneValue || "");

  return (
    <Styles
      errorMessage={errorMessage}
      validateOnChange={validateOnChange}
      borderColor={borderColor}
    >
      <div className="phone-input-control">
        <select
          className="phone-country-select"
          value={selectedCountry}
          onChange={(e) => setSelectedCountry(e.target.value)}
          disabled={isDisabled}
        >
          {availableCountries.map((countryCode) => (
            <option key={countryCode} value={countryCode}>
              {getFlagEmoji(countryCode)}
            </option>
          ))}
        </select>
        <PhoneInput
          className="phone-number-input"
          country={selectedCountry}
          international
          withCountryCallingCode
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={isDisabled}
        />
      </div>
    </Styles>
  );
};

export default PhoneNumberInput;
